import StarAllianceLogo from "@/assets/img/star-alliance-logo.svg";
import FooterLinks from "@/components/headtail/FooterLinks";


export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer__container">
                <div className="footer__column footer__column--left">
                    <div className="footer__logo-top">
                        <span className="fi-logo-horizontal" />
                    </div>
                    <div className="footer__column footer__column--left">
                        <div className="footer__logo-bottom">
                            <span className="fi-logo-further" />
                        </div>
                    </div>
                </div>

                <div className="footer__column footer__column--right">
                    <div className="footer__stores">
                        <a target="_blank" rel="noopener noreferrer"
                            href="https://play.google.com/store/apps/details?id=network.further.furtherpass.prod">
                            <span className="fi-store-google badges" />
                        </a>
                        <a target="_blank" rel="noopener noreferrer"
                            href="https://apps.apple.com/app/furtherpass/id1582819895">
                            <span className="fi-store-apple badges" />
                        </a>
                    </div>
                    <p className="footer__description">
                        All your Travel Documents at your fingertips with FurtherPass Application.
                    </p>
                    <a href="mailto:furtherpass@further.network" className="footer__email">
                        furtherpass@further.network
                    </a>
                    <div className="footer__trusted">
                        <span>Trusted by</span>
                        <img src={StarAllianceLogo} alt="Star Alliance Logo" className="footer__trusted-logo" />
                    </div>

                    <FooterLinks />

                    <p className="footer__copyright">
                        © 2020-2025 Further Network<br />
                        Further Corporation Limited<br />
                        4th floor, 40 Gracechurch Street, London, EC3V 0BT, United Kingdom
                    </p>
                </div>
            </div>

        </footer>

    );
}
